// src/store/bracket/actions/actionTypes.js

export const SET_LOADING = "SET_LOADING";
export const GET_BRACKETS = "GET_BRACKETS";
export const GET_BRACKET_BY_ID = "GET_BRACKET_BY_ID";
export const GET_BRACKETS_BY_DIVISION = "GET_BRACKETS_BY_DIVISION";
export const CREATE_BRACKET = "CREATE_BRACKET";
export const GENERATE_BRACKET = "GENERATE_BRACKET";
export const UPDATE_GAME_RESULT = "UPDATE_GAME_RESULT";
export const UPDATE_BRACKET_STATUS = "UPDATE_BRACKET_STATUS";
export const DELETE_BRACKET = "DELETE_BRACKET";
export const CLEAR_BRACKET = "CLEAR_BRACKET";
export const PUBLISH_BRACKET = "PUBLISH_BRACKET"; // ⭐ NEW
